export const ERRORS = {
    PAS_VALIDATION_ERROR: {
        errorCode: 9001,
        errorMessage: 'PAS validation failed.'
    },
    RE_CAPTCHA_EXPIRATION_ERROR: {
        errorCode: 9002,
        errorMessage: 'reCAPTCHA response expires.'
    },
    RE_CAPTCHA_ANY_ERROR: {
        errorCode: 9003,
        errorMessage: 'reCAPTCHA encounters an error.'
    },
    SCRIPT_LOADING_ERROR: {
        errorCode: 9004,
        errorMessage: 'Script loading error.'
    }
};
